import axios from 'axios';

export const uploadFile = async ({ payload, headers }, onUploadProgress) => {
  try {
    const { file, folder } = payload;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    const response = await axios.post(`${process.env.REACT_APP_API_UPLOAD_BASE_URL}/`, formData, {
      headers: {
        ...headers,
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress
    });
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
